
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import AcoTiersList from '@/app/components/FeesAndCharges/AcoTiersList.vue';
import { BankingScheme, AcoTier, FeePaymentType, FundingCharge } from 'ah-api-gateways';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';

/**
 * Show ACO Tiers for payment fees
 *
 * Uses Global values as reference
 */
@Component({
  components: { AcoTiersList },
})
export default class AcoTiersModal extends Mixins(WithRequestManager) {
  $refs!: {
    acoTiersFormModal: BModal;
  };

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadPartnerFees') {
      this.loadPartnerFees();
    }
  }

  private partnerFees: FundingCharge[] = [];

  @Watch('requestManager.anyPending', { immediate: true })
  onSubmitStateChange() {
    this.$emit('update:formBusy', this.requestManager.anyPending);
  }

  private get tierList() {
    return [
      { value: AcoTier.ACO_TIER_1, label: 'Tier 1' },
      { value: AcoTier.ACO_TIER_2, label: 'Tier 2' },
      { value: AcoTier.ACO_TIER_3, label: 'Tier 3' },
      { value: AcoTier.ACO_TIER_4, label: 'Tier 4' },
    ];
  }

  @Watch('partnerId', { immediate: true })
  private loadPartnerFees() {
    this.requestManager
      .currentOrNew(
        'loadPartnerFees',
        this.$services.fees.listAHFees({
          type: FeePaymentType.PAYMENT,
          sort: 'bankingScheme,desc',
          bankingScheme: BankingScheme.SWIFT,
          pageSize: 1000,
        })
      )
      .subscribe((response) => {
        this.partnerFees = response ?? null;
      });
  }

  showModal() {
    this.$refs.acoTiersFormModal.show();
  }
}
